import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAllowedApps } from "../../hooks/useAllowedApps";

/**
 * Komfort-Gate für private Story-Deep-Links, auch vor dem mobilen Top-Level-Launch.
 * Die verbindliche Prüfung bleibt im serverseitigen /launch/story-RBAC-Gate.
 * Weder Core-Branding noch GF-Rollenname oder SATELLITES erteilen Zugriff.
 */
export function StoryAccessRoute({ children }: { children: ReactNode }) {
  const { allowed, loading } = useAllowedApps();
  if (loading) {
    return <div role="status">App-Berechtigung wird geprüft…</div>;
  }
  if (!allowed?.has("story")) {
    return <Navigate to="/home" replace />;
  }
  return <>{children}</>;
}
